module.exports = __webpack_public_path__ + "static/media/plug-icon.ce8f491e.svg";